import { render, staticRenderFns } from "./DocumentRevisions.vue?vue&type=template&id=7e81a110&"
import script from "./DocumentRevisions.vue?vue&type=script&lang=js&"
export * from "./DocumentRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports